import i18next, { type i18n } from 'i18next';
import { initReactI18next } from 'react-i18next';
import koCommon from './resources/ko/common.json';
import jaCommon from './resources/ja/common.json';

export const SUPPORTED_LOCALES = ['ko', 'ja'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const resources = {
  ko: { common: koCommon },
  ja: { common: jaCommon },
} as const;

export interface CreateI18nOptions {
  /** 초기 언어 (기기/프로필 설정) */
  lng?: SupportedLocale;
}

/**
 * 앱별 i18n 인스턴스 팩토리.
 * 새 UI 문자열은 ko/ja 리소스에 동시 추가한다 (CLAUDE.md 규칙 6).
 * zh-TW 확장 시 SUPPORTED_LOCALES와 resources에 추가만 하면 된다.
 */
export function createI18n({ lng = 'ko' }: CreateI18nOptions = {}): i18n {
  const instance = i18next.createInstance();
  void instance.use(initReactI18next).init({
    lng,
    fallbackLng: 'ko',
    supportedLngs: [...SUPPORTED_LOCALES],
    defaultNS: 'common',
    ns: ['common'],
    resources,
    interpolation: { escapeValue: false },
    returnEmptyString: false,
  });
  return instance;
}

export function isSupportedLocale(value: string): value is SupportedLocale {
  return (SUPPORTED_LOCALES as readonly string[]).includes(value);
}
